
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/donation/detail/[id]",
      function () {
        return require("private-next-pages/community/donation/detail/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/donation/detail/[id]"])
      });
    }
  